import BadRequestErrorResponse from "@app/config/api/responses/BadRequestErrorResponse";
import { badRequestWithSuggestionResponseSchema } from "@app/config/api/responses/BadRequestErrorResponse";
import type { GenericErrorWithSuggestionResponse } from "@globals";
import { safeParse } from "valibot";

export const DEFAULT_DATASET_PARSE_SUGGESTION =
  "Please check that the file format and content is correct. Contact support if the problem persists.";

export default function parseDatasetError(error: unknown): GenericErrorWithSuggestionResponse {
  if (error instanceof BadRequestErrorResponse) {
    const result = safeParse(badRequestWithSuggestionResponseSchema, error.json);
    if (result.success) {
      return {
        message: result.output.message,
        extra: { suggestion: result.output.extra.suggestion }
      };
    }
  }

  return {
    message: "An unexpected error ocurred.",
    extra: { suggestion: DEFAULT_DATASET_PARSE_SUGGESTION }
  };
}
